import { CaptureType } from './report-image.model';

export class ReportImage {
	snapshot: any;
	captureType: CaptureType;
	smartTagTypeList: [];
	isFormValid: boolean;
	successUpload: boolean;
	disabledControls: boolean;

	constructor() {
		this.snapshot = null;
		this.smartTagTypeList = [];
		this.isFormValid = false;
		this.successUpload = false;
		this.disabledControls = false;
	}
}
